import React from "react";
import post2 from '../assets/image/post2.jpg';
import post3 from '../assets/image/post3.jpg';
import post4 from '../assets/image/post4.jpg';



const BlogPage = () => {
  const posts = [
    {
      id: 1,
      title: "The Future of Trade in Sri Lanka",
      excerpt: "Explore the innovative trends shaping the future of trade and business in Sri Lanka...",
      image: post2,
      date: "July 20, 2024",
    },
    {
      id: 2,
      title: "How to Scale Your Business Effectively",
      excerpt: "Learn the best strategies for scaling a business from startup to success...",
      image: post3,
      date: "July 15, 2024",
    },
    {
      id: 3,
      title: "Why Sustainability is Key for Future Growth",
      excerpt: "Sustainability is the cornerstone of long-term success. Find out why it matters...",
      image: post4,
      date: "July 10, 2024",
    },
  ];

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f9f9f9",
        padding: "20px",
        color: "#333",
      }}
    >
      {/* Blog Header */}
      <header
        style={{
          textAlign: "center",
          padding: "40px 20px",
          backgroundColor: "#007bff",
          color: "white",
          borderRadius: "10px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h1 style={{ fontSize: "48px", marginBottom: "20px" }}>Atlas Trade Center Blog</h1>
        <p style={{ fontSize: "18px", lineHeight: "1.8", maxWidth: "800px", margin: "0 auto" }}>
          Stay up to date with the latest news, trends, and insights from the world of trade, business, and innovation.
        </p>
      </header>

      {/* Featured Posts Section */}
      <section
        style={{
          margin: "50px 0",
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
          justifyContent: "center",
        }}
      >
        <h2 style={{ fontSize: "36px", color: "#333", marginBottom: "30px", width: "100%" }}>Featured Posts</h2>
        {posts.slice(0, 3).map((post) => (
          <div
            key={post.id}
            style={{
              width: "300px",
              backgroundColor: "white",
              borderRadius: "10px",
              boxShadow: "0 6px 18px rgba(0, 0, 0, 0.1)",
              overflow: "hidden",
            }}
          >
            <img
              src={post.image}
              alt={post.title}
              style={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
              }}
            />
            <div style={{ padding: "20px" }}>
              <h3 style={{ fontSize: "22px", color: "#007bff", marginBottom: "10px" }}>{post.title}</h3>
              <p style={{ fontSize: "16px", color: "#555", marginBottom: "15px" }}>{post.excerpt}</p>
              <span style={{ fontSize: "14px", color: "#777" }}>{post.date}</span>
            </div>
          </div>
        ))}
      </section>

      {/* Blog Categories */}
      <section
        style={{
          marginBottom: "50px",
          display: "flex",
          justifyContent: "center",
          gap: "20px",
        }}
      >
        <h2 style={{ fontSize: "36px", color: "#333", marginBottom: "30px", width: "100%" }}>Blog Categories</h2>
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "20px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
            width: "200px",
          }}
        >
          <h4 style={{ fontSize: "20px", color: "#007bff", marginBottom: "15px" }}>Trade Insights</h4>
          <p style={{ fontSize: "14px", color: "#555" }}>Articles on global trade practices and trends.</p>
        </div>
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "20px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
            width: "200px",
          }}
        >
          <h4 style={{ fontSize: "20px", color: "#007bff", marginBottom: "15px" }}>Business Growth</h4>
          <p style={{ fontSize: "14px", color: "#555" }}>Tips and guides to help your business scale and grow.</p>
        </div>
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "20px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
            width: "200px",
          }}
        >
          <h4 style={{ fontSize: "20px", color: "#007bff", marginBottom: "15px" }}>Sustainability</h4>
          <p style={{ fontSize: "14px", color: "#555" }}>Learn how sustainability is shaping the future of businesses.</p>
        </div>
      </section>

      {/* Latest Posts Section */}
      <section
        style={{
          marginBottom: "50px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h2 style={{ fontSize: "36px", color: "#333", marginBottom: "30px" }}>Latest Posts</h2>
        {posts.map((post) => (
          <div
            key={post.id}
            style={{
              width: "80%",
              backgroundColor: "white",
              borderRadius: "10px",
              boxShadow: "0 6px 18px rgba(0, 0, 0, 0.1)",
              marginBottom: "30px",
              overflow: "hidden",
            }}
          >
            <img
              src={post.image}
              alt={post.title}
              style={{
                width: "100%",
                height: "300px",
                objectFit: "cover",
              }}
            />
            <div style={{ padding: "20px" }}>
              <h3 style={{ fontSize: "24px", color: "#007bff", marginBottom: "10px" }}>{post.title}</h3>
              <p style={{ fontSize: "16px", color: "#555", marginBottom: "15px" }}>{post.excerpt}</p>
              <span style={{ fontSize: "14px", color: "#777" }}>{post.date}</span>
            </div>
          </div>
        ))}
      </section>

      {/* Footer */}
      <footer
        style={{
          textAlign: "center",
          padding: "20px",
          backgroundColor: "#333",
          color: "white",
          borderRadius: "10px",
        }}
      >

      </footer>
    </div>
  );
};

export default BlogPage;
